// extracted by mini-css-extract-plugin
export default {"info":"Footer_info__68utD","github":"Footer_github__Efl97","calendarIcon":"Footer_calendarIcon__F3tte","infoReleaseCalendar":"Footer_infoReleaseCalendar__JFWZl"};